import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService } from 'primeng/dynamicdialog';
import { defaultListPaginationParameters } from '../../../data-access';
import { SoftDeletableAuditableLookupsComponent } from '../../../lookups';
import { ActionConfigFactory, ActionTypeEnum, ActionTypeHandlerEnum, IActionConfig } from '../../../ui';
import { IStatesApiClient, StatesApiClientProvider } from '../clients';
import { IStateResponse } from '../dtos';

import { LocationManagementPermissions } from '../../common/permissions';
import { CreateUpdateStateComponent } from '../../../../../trash/location-management';

@Component({
  selector: 'app-states',
  standalone: true,
  providers: [],
  imports: [CommonModule, SoftDeletableAuditableLookupsComponent],
  templateUrl: './states.component.html',
  styleUrls: ['./states.component.scss']
})
export class StatesComponent {
  client: IStatesApiClient = inject(StatesApiClientProvider).getClient();
  dialogService = inject(DialogService);
  translate = inject(TranslateService);
  router = inject(Router);
  defualtPaginationParameters = defaultListPaginationParameters;

  supportedActions: IActionConfig<IStateResponse>[] = [
    ActionConfigFactory.createDialog(this.dialogService, {
      type: ActionTypeEnum.VIEW,
      componentType: CreateUpdateStateComponent,
      headerResolver: (x) =>
        `${this.translate.instant('LOCATION_MANAGEMENT.STATE')} ${this.translate.currentLang === 'ar' ? `'${x!.arabicName}'` : `'${x!.englishName}'`
        }`,
      permission: LocationManagementPermissions.States.Read
    }),
    {
      type: ActionTypeEnum.CREATE,
      label: `${this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('LOCATION_MANAGEMENT.NEW_STATE')}`,
      handlerType: ActionTypeHandlerEnum.DIALOG,
      handlerConfig: {
        componentType: CreateUpdateStateComponent,
        configResolver: (item?: IStateResponse) => ({
          data: {
            item: item,
            visible: true
          },
          header: `${this.translate.instant('GENERAL.CREATE')} ${this.translate.instant('LOCATION_MANAGEMENT.STATE')}`
        }),
        service: this.dialogService
      },
      permission: LocationManagementPermissions.Countries.Create
    },
    {
      type: ActionTypeEnum.UPDATE,
      handlerType: ActionTypeHandlerEnum.DIALOG,
      handlerConfig: {
        componentType: CreateUpdateStateComponent,
        configResolver: (item?: IStateResponse) => ({
          data: {
            item: item,
            visible: true
          },
          header: `${this.translate.instant('LOCATION_MANAGEMENT.STATE')} ${this.translate.currentLang === 'ar' ? `'${item!.arabicName}'` : `'${item!.englishName}'`
            }`,
        }),
        service: this.dialogService
      },
      permission: LocationManagementPermissions.Countries.Update
    }
  ];
}
